import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/store.js";
import vuetify from "./plugins/vuetify";
import VuetifyDialogPromise from "vuetify-dialog-promise";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@mdi/font/css/materialdesignicons.css";
import "@fortawesome/fontawesome-free/css/all.css";
import Vuetify from "vuetify";
import Vuelidate from "vuelidate";
//import i18n from "./i18n";
import { initI18n } from './i18n'

import VueDraggable from "vue-draggable";
import VueSocketIO from "vue-socket.io-extended";
import $socket from "./plugins/socket-instance";
import VueTour from "vue-tour";
import LevamSupportWindow from "levam-support-window";
import VuePlyr from 'vue-plyr';
import 'vue-plyr/dist/vue-plyr.css';
import "./plugins/vuetify-mask.js";
import VueHtmlToPaper from 'vue-html-to-paper';
Vue.use(VueHtmlToPaper);



const moment = require("moment");
Vue.use(require("vue-moment"), {
  moment,
});
Vue.use(LevamSupportWindow);
Vue.use(VueDraggable);
Vue.use(VueSocketIO, $socket);
Vue.use(Vuelidate);
Vue.use(VuePlyr, {
  plyr: {}
})

Vue.use(VuetifyDialogPromise, {
  snackbarParent: "app",
  locale: "ru",
  snackbarX: "center",
  snackbarY: "bottom",
  theme: {
    dark: true,
  },
});
require("vue-tour/dist/vue-tour.css");
Vue.use(VueTour);
Vue.prototype.$apiURL = process.env.VUE_APP_API_URL;
Vue.prototype.$imgDummyPath = process.env.VUE_APP_IMG_DUMMY_PATH;


initI18n(Vue.prototype.$apiURL).then((i18n)=> {
  Vue.prototype.i18n = i18n;
  Vue.prototype.isErrorLoading18n = Object.keys(i18n.messages).length === 0;
  var vm = new Vue({
    i18n,
    router,
    store,
    vuetify,
    render: function (h) {
      return h(App);
    },
  }).$mount("#app");
})